<template>
  <div>
    <vx-card>
      <div class="flex items-center gap-3 font-medium">
        <p style="width: 114px">연도</p>
        <vs-select v-model="targetYear" autocomplete @change="loadData">
          <vs-select-item :key="year" v-for="year in yearList" :value="year" :text="year" />
        </vs-select>
      </div>
    </vx-card>

    <div class="flex items-center justify-end my-4">
      <vs-button type="border" color="secondary" @click="excelDownWithHtml('risk_result')">Excel 다운로드</vs-button>
    </div>

    <risk-evaluation-table id="risk_result" :risk-list="riskList"/>
  </div>
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import FileUploadModule from "@/views/modules/FileUploadModule";
import DateSelector from "@/components/selector/DateSelector";
import HttpRequest from "@/util/HttpRequest";
import XLSX from "xlsx";
import RiskEvaluationTable from "@/views/boards/single-page/608/RiskEvaluationTable.vue";

export default {
  components: {
    RiskEvaluationTable,
    FieldSelectModule,
    FileUploadModule,
    DateSelector,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  data() {
    return {
      targetYear: new Date().getFullYear().toString(), // 현재 년도로 초기화
      yearList: this.generateYearList(2023, new Date().getFullYear()), // 2023년부터 현재 년도까지
      riskList: [],
    };
  },
  computed: {
    projectId() {
      return parseInt(this.$route.params.proj_id);
    },
  },
  mounted() {
    this.loadData()
  },
  methods: {
    generateYearList(start, end) {
      const result = [];
      for (let year = start; year <= end; year++) {
        result.push(year.toString());
      }
      return result;
    },
    excelDownWithHtml(tableName) {
      let wb = XLSX.utils.table_to_book(document.getElementById(tableName), { sheet: "위해위험요인별 결과", raw: true });
      XLSX.writeFile(wb, "위해위험요인별 결과.xlsx");
    },
    loadData() {
      const params = {
        params: {
          targetYear: this.targetYear,
          projectId: this.projectId
        }
      }
      new Promise((resolve, reject) => {
        HttpRequest.get(`/api/v1/summary/post/161`, params)
          .then(response => {
            this.riskList = response
            console.log("riskList", this.riskList)
          }).catch(err => reject(err))
      })
    },
  },
};
</script>
